import { ExternalLinkIcon, MessageIcon } from 'components/icons';
import { CardBackground } from 'components/ui';

export const HelpPrompt = () => {
  return (
    <CardBackground>
      <div className="w-full p-5 lg:p-10">
        <div className="w-16 h-16 px-3 py-4 border rounded-full border-segments-accent-color-2">
          <MessageIcon />
        </div>
        <div className="mt-8">
          <p className="text-2xl leading-7">Want to know more?</p>
          <p className="mt-6 text-base text-black text-opacity-50">
            Refer to our help articles, case studies and Blog.
          </p>
        </div>

        <div className="mt-8 space-y-4 lg:flex lg:space-y-0 lg:space-x-4">
          <a
            href="https://help.tresl.co/en/"
            target="_blank"
            rel="noreferrer"
            className="flex font-bold border border-segments-accent-color-1 text-segments-accent-color-1 rounded-2xl justify-center py-[14px] space-x-0.5 items-start px-4"
          >
            <p>Help articles</p>
            <ExternalLinkIcon className="inline w-5 h-5 align-middle" />
          </a>
          <a
            href="https://www.tresl.co/case-studies"
            target="_blank"
            rel="noreferrer"
            className="flex font-bold border border-segments-accent-color-1 text-segments-accent-color-1 rounded-2xl justify-center  py-[14px] space-x-0.5 items-start px-4"
          >
            <p>Case studies</p>
            <ExternalLinkIcon className="inline w-5 h-5 align-middle" />
          </a>
          <a
            href="https://www.tresl.co/blog"
            target="_blank"
            rel="noreferrer"
            className="flex font-bold border border-segments-accent-color-1 text-segments-accent-color-1 rounded-2xl justify-center py-[14px] space-x-0.5 items-start px-8"
          >
            <p>Blog</p>
            <ExternalLinkIcon className="inline w-5 h-5 align-middle" />
          </a>
        </div>
      </div>
    </CardBackground>
  );
};
